import { Link } from 'react-router-dom'

// The "open this company" arrow. ONE component for the job page (AddressesTab) and the AutoJobs confirm step, so both look and behave the same:
// opens the company page in a new tab. With no company yet (a company that will only be created on confirm) it is shown disabled with the
// reason, so staff do not wonder where the icon went.
export default function CompanyLink({ customerId, editTarget, disabledTitle }: {
  customerId?: string | null
  editTarget?: 'eori' | null            // only set when the company's EORI is missing/wrong: the page opens with its Edit form on EORI
  disabledTitle?: string
}) {
  const icon = (
    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
      <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
    </svg>
  )
  if (!customerId) {
    const title = disabledTitle || 'No company to open yet'
    return (
      <span title={title} aria-label={title} aria-disabled="true" className="text-gray-300 dark:text-gray-600 cursor-not-allowed">{icon}</span>
    )
  }
  const title = editTarget === 'eori' ? 'Open the company and add its EORI' : 'Open customer record'
  return (
    <Link
      to={`/customers/${customerId}${editTarget ? `?edit=${editTarget}` : ''}`}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      aria-label={title}
      className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
    >
      {icon}
    </Link>
  )
}
